import React, { useEffect } from "react";
import { Container, Box, Typography, Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

export default function Post() {
  const navigate = useNavigate();
  const { id,postType } = useParams(); // Get the post ID from the URL

  useEffect(() => {
    console.log("Received post ID:", id);
  }, [id]);
  const handleOpenApp = () => {
    const APP_SCHEME = 'aiscene';

    if (!id) return;

    const deepLinkUrl = `${APP_SCHEME}://post/${postType}/${id}`;
    console.log('deepLinkUrl:',deepLinkUrl)
    // 2. 딥 링크 호출
    window.location.href = deepLinkUrl;

    // 3. (선택) 딥 링크 실패 시 앱 스토어로 리디렉션
    // 딥 링크 시도는 브라우저에서 보통 1-2초 내에 이루어집니다.
    // 실패하면 앱이 설치되지 않았다고 간주하고 스토어로 리디렉션합니다.
    setTimeout(() => {
      // 실제 앱 스토어/플레이 스토어 URL로 교체하세요.
      const appStoreUrl = 'https://apps.apple.com/app/id6754524422';
      const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.juseung.aiscenes';
      window.location.href = appStoreUrl
      // 간단하게 모바일 OS를 구분하여 스토어로 안내할 수 있습니다.
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      let redirectUrl = deepLinkUrl; // 기본은 딥 링크를 유지하여 유니버설 링크/앱 링크 기능을 사용하도록 유도

      // iOS 환경 확인
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        redirectUrl = appStoreUrl;
      }
      // Android 환경 확인
      else if (/android/i.test(userAgent)) {
        redirectUrl = playStoreUrl;
      }

      // 딥 링크가 실패하면 (앱이 설치되지 않은 경우) 스토어로 이동
      // 유니버설 링크/앱 링크는 웹 URL을 사용하며, OS가 알아서 처리하므로 이 타이머는 커스텀 스킴(aiscenes://)이 실패했을 때 유용합니다.
      // window.location.href = redirectUrl; // 🚨 실제 운영 환경에서만 주석 해제
 window.location.href = deepLinkUrl;
    }, 2500); // 2.5초 후 실행
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        mt: 8,
        textAlign: "center",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
      }}
    >
        <Button
        onClick={() => navigate('/')}
        sx={{
          position: "absolute",
          top: 20,
          left: 20,
          color: "white",
          textDecoration: "underline",
          fontSize: 16,
        }}
      >
        Home
      </Button>
      <Box
        sx={{
          bgcolor: "#1c1c1e",
          p: 4,
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          width: "100%",
        }}
      >
        {/* Profile Image */}
        <Box
          sx={{
            width: 90,
            height: 90,
            borderRadius: "50%",
            overflow: "hidden",
          }}
        >
          <img
            src="/logo.png" // 🔥 Add your profile image here
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            alt="Profile"
          />
        </Box>

        <Typography sx={{ fontSize: 22, fontWeight: 700 }}>
          Check out this post in the app
        </Typography>

        <Typography sx={{ opacity: 0.8, fontSize: 14 }}>
          Use the app to see all comments and explore more posts.
        </Typography>

        {/* Open App Button */}
        <Button
          variant="contained"
          fullWidth
          sx={{
            mt: 1,
            height: 50,
            fontSize: 18,
            borderRadius: 3,
          }}
          onClick={() => {
            handleOpenApp()
           // navigate(`/app?id=${id}`);
          }}
        >
          Open App
        </Button>

        {/* Sign Up Text */}
        <Typography
        
          sx={{ mt: 1, fontSize: 15, textDecoration: "underline", opacity: 0.8 }}
        >
          Sign Up
        </Typography>
      </Box>
    </Container>
  );
}
